(function () {
  'use strict';

  var section = document.getElementById('Pdp-Ratings-Section');
  if (!section) return;

  bindShowMore();
  applyResponsiveTextClasses();

  /* Karten ab der fünften rendert Liquid mit --hidden; der Button blendet alle ein */
  function bindShowMore() {
    var showMoreBtn = section.querySelector('[data-show-more]');
    if (!showMoreBtn) return;
    showMoreBtn.addEventListener('click', function () {
      var hidden = section.querySelectorAll('.Pdp-Ratings-Reviews-Card--hidden');
      for (var i = 0; i < hidden.length; i++) {
        hidden[i].classList.remove('Pdp-Ratings-Reviews-Card--hidden');
      }
      showMoreBtn.style.display = 'none';
    });
  }

  /* Tauscht Textgrößen-Klassen je nach Viewport beim Laden des Skripts (kein Resize-Listener) */
  function applyResponsiveTextClasses() {
    var w = window.innerWidth;

    var swap = function (selector, removeClass, addClass) {
      section.querySelectorAll(selector).forEach(function (el) {
        el.classList.remove(removeClass);
        el.classList.add(addClass);
      });
    };

    if (w >= 320 && w <= 767) {
      swap('.Pdp-Ratings-Product-Rating > p', 'text-body-l-bold', 'text-body-m-bold');
      swap('.Pdp-Ratings-S-Text', 'text-body-m', 'text-body-s');
      swap('.Pdp-Ratings-Category-Wrapper p:first-child', 'text-body-l-bold', 'text-body-m-bold');
      swap('.Pdp-Ratings-Category-Wrapper p:not(:first-child)', 'text-body-l', 'text-body-m');
    } else if (w >= 768) {
      swap('.Pdp-Ratings-Product-Rating > p', 'text-body-m-bold', 'text-body-l-bold');
      swap('.Pdp-Ratings-S-Text', 'text-body-s', 'text-body-m');
      swap('.Pdp-Ratings-Category-Wrapper p:first-child', 'text-body-m-bold', 'text-body-l-bold');
      swap('.Pdp-Ratings-Category-Wrapper p:not(:first-child)', 'text-body-m', 'text-body-l');
    }
  }
})();
